import React from "react";
import { Link } from "react-router-dom";

const NoPage = () => {
  const styles = {
    color: "white",
  };
  return (
    <>
      <h1 style={styles}>page doesnt exist</h1>
      <h3 style={styles}>
        click <Link to="/">here</Link> to go back to the main page
      </h3>
    </>
  );
};
export default NoPage;
